export default __webpack_public_path__ + "static/media/Imperial-Fleet-04.3d1196ed.jpg";